$(function () {
  const banner = $(".left-slide-banner").leftSlideBanner();

  const element = $(".time-left-banner");
  const elementContent = element.find(".time-left-banner-content");
  const elementContentText = elementContent.html();

  let timeLeftCookie = Cookies.get("timeLeft");

  if (!timeLeftCookie && window.location.pathname.includes("/letter/choose")) {
    var offset = 60 * 60000;
    var actualMinutes = new Date().getMinutes()
    var minutesOffset = actualMinutes < 30 ? 30 - actualMinutes : 60 - actualMinutes
    offset += minutesOffset * 60000;
    timeLeftCookie = new Date(new Date().getTime() + offset);
    Cookies.set("timeLeft", timeLeftCookie.toString(), { secure: true });
  }

  if (timeLeftCookie && window.location.pathname.includes("/success")) {
    Cookies.remove("timeLeft");
    timeLeftCookie = new Date();
  }

  if (new Date(timeLeftCookie) - new Date() >= 0) {
    if (!$("#AIBanner").length && !$(".simple-banner").length) {
      banner.open();
      var minutesToBeDisplayed = new Date(timeLeftCookie).getMinutes() + '';
      if(elementContentText) {
        let text = elementContentText.replace("{h}", `${new Date(timeLeftCookie).getHours()}:${minutesToBeDisplayed.length === 1 ? `0${minutesToBeDisplayed}` : minutesToBeDisplayed}`);
        elementContent.html(text);
      }
    } else if(!$("#AIBanner").length && $(".simple-banner").length){
      banner.open();
    }
  }

  element.on("click", ".time-left-banner-button", () => {
    banner.close();
    Cookies.set("timeLeft", new Date().toString());
  });
});
